import styled from 'styled-components';

export const Enter = styled.div`
  margin-bottom: 40px;
`;

export const Confirm = styled.div`
  margin-bottom: 26px;
`;
